import { render, staticRenderFns } from "./AdministrativeProcurementA.vue?vue&type=template&id=71a50bf0&scoped=true"
import script from "./AdministrativeProcurementA.vue?vue&type=script&lang=js"
export * from "./AdministrativeProcurementA.vue?vue&type=script&lang=js"
import style0 from "./AdministrativeProcurementA.vue?vue&type=style&index=0&id=71a50bf0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a50bf0",
  null
  
)

export default component.exports